var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"my-3"},[_c('b-row',[_c('b-col',[_c('BsiMultiChanges',{attrs:{"data":_vm.getBsiContinuousFilingTask.data}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }